<template>
  <!--
    M7, Tela 3 (balão ⑮): a linha "Check no app" NUNCA mostra um "exigido" solto —
    ela sempre termina dizendo quem decidiu, a política vigente ou a configuração
    legada da escala. Enquanto o backend não expõe os campos novos, `line` é `null`
    e a linha some: o modal fica idêntico ao de hoje.
  -->
  <div
    v-if="line"
    data-testid="station-required-check-line"
    class="flex flex-col gap-1 text-left md:flex-row md:items-start md:gap-2"
  >
    <span class="text-sm font-bold text-textPrimary md:min-w-[110px]">Check no app</span>

    <div class="flex flex-col gap-1">
      <div class="flex flex-wrap items-center gap-1">
        <LabelBadge
          :label="line.statusLabel"
          :color="line.required ? 'green' : 'gray'"
          size="small"
          :icon="null"
          data-testid="station-required-check-status"
        />
        <span v-if="line.methodLabel" class="text-sm text-textPrimary"
          >· {{ line.methodLabel }}</span
        >
      </div>

      <div class="flex flex-wrap items-center gap-1 text-xs text-gray-600">
        <span data-testid="station-required-check-source">{{ line.sourceLabel }}</span>
        <span aria-hidden="true">·</span>
        <button
          type="button"
          class="text-primary30 underline font-semibold"
          :class="{ 'min-h-[40px]': touchTarget }"
          data-testid="station-required-check-link"
          @click="emit('openPolicy')"
        >
          {{ line.linkLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { CheckMethod } from '@/constants/ds-attendance.constants'
import {
  buildStationCheckLine,
  type RequiredCheckPolicyRef,
  type RequiredCheckSource,
  type ScheduleCheckFlags
} from '@/utils/registrationCheck'

const props = withDefaults(
  defineProps<{
    /** Quem decidiu a exigência. Ausente = backend ainda não expõe → não renderiza nada. */
    requiredCheckSource?: RequiredCheckSource | null
    requiredCheckPolicy?: RequiredCheckPolicyRef | null
    requiredCheck?: boolean | null
    requiredCheckMethod?: CheckMethod | null
    /** O plantão é do time interno? Decide qual flag legada da escala responde. */
    ourTeam?: boolean | null
    /** Flags legadas da escala, usadas só na transição (fonte `SCHEDULE`). */
    scheduleFlags?: ScheduleCheckFlags | null
    /** Alvo de toque de 40px no link "ver/criar política" (celular, R6). */
    touchTarget?: boolean
  }>(),
  {
    requiredCheckSource: null,
    requiredCheckPolicy: null,
    requiredCheck: null,
    requiredCheckMethod: null,
    ourTeam: null,
    scheduleFlags: null,
    touchTarget: false
  }
)

const emit = defineEmits<{ openPolicy: [] }>()

const line = computed(() =>
  buildStationCheckLine({
    requiredCheckSource: props.requiredCheckSource,
    requiredCheckPolicy: props.requiredCheckPolicy,
    requiredCheck: props.requiredCheck,
    requiredCheckMethod: props.requiredCheckMethod,
    ourTeam: props.ourTeam,
    scheduleFlags: props.scheduleFlags
  })
)
</script>
